import CloseIcon from 'assets/icons/ims/Close3.svg'
import ClockIcon from 'assets/icons/ims/Clock.svg'
import OkIcon from 'assets/icons/ims/Ok.svg'

// ProtocolApprovmentStatuses ids (1=Waiting, 2=Approved, 3=Rejected) - distinct from
// statusMap.ts (Protocol.ProtocolStatusId). Reuses the same color palette for consistency.
// Title is translated here rather than taken from the API - StatusName in the DB
// (ProtocolApprovmentStatuses) is stored in English for internal use.
export const APPROVMENT_STATUS_MAP: Record<number, { titleKey: string; color: string; bg: string; icon: string }> = {
  1: { titleKey: 'protocols:status_pending',  color: '#4C5564', bg: '#F1F5F9', icon: ClockIcon },
  2: { titleKey: 'protocols:status_approved', color: '#00A63E', bg: '#DCFCE7', icon: OkIcon },
  3: { titleKey: 'protocols:status_rejected', color: '#E7000B', bg: '#FEE2E2', icon: CloseIcon },
}
